require('./bootstrap');

import Vue from 'vue';
import {App, plugin} from '@inertiajs/inertia-vue';
import {InertiaForm} from 'laravel-jetstream';
import PortalVue from 'portal-vue';
import vSelect from 'vue-select';
import moment from 'moment';
import VueTheMask from 'vue-the-mask';
import money from 'v-money';
import Datepicker from 'vuejs-datepicker';
import Password from 'vue-password-strength-meter'
import VueToast from 'vue-toast-notification';
import vClipboard from 'v-clipboard';
import {InertiaProgress} from '@inertiajs/progress';
import IdleLogOut from './Mixins/IdleLogOut';
import VueTippy, { TippyComponent } from 'vue-tippy';

const isNotTest = process.env.NODE_ENV !== 'test'

export const vueExtesionsAndPlugins = () => {
    Vue.mixin({ methods: { route: isNotTest ? route : (route) => route }});
    Vue.mixin(IdleLogOut);
    Vue.use(plugin);
    Vue.use(InertiaForm);
    Vue.use(PortalVue);
    Vue.use(moment);
    Vue.use(VueTheMask);
    Vue.use(money, { precision: 4 });
    Vue.use(VueToast);
    Vue.use(vClipboard);
    Vue.use(VueTippy, {
        directive: "tippy", // => v-tippy
        flipDuration: 0,
        popperOptions: {
            modifiers: {
                preventOverflow: {
                    enabled: false
                }
            }
        }
    });
    Vue.component('v-select', vSelect);
    Vue.component('datepicker', Datepicker);
    Vue.component('password', Password);
}

export const vueFilters = () => {
    Vue.filter('number', function (value) {
        return parseInt(value).toLocaleString('pt-BR', {minimumFractionDigits: 0, maximumFractionDigits: 0})
    });

    Vue.filter('capitalizeName', function (value) {
        if (!value) {
            return '';
        }
        try {
            value = value.toString();
        } catch (err) {
        }
        const smallWords = /^(de|da|do|e)$/i;
        return value.toLowerCase().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
            if (index > 0 && index + match.length !== title.length &&
                match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                (title.charAt(index + match.length) !== "'" || title.charAt(index - 1) === "'") &&
                title.charAt(index - 1).search(/[^\s-]/) < 0) {
                return match.toLowerCase();
            }
            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }
            return match.charAt(0).toUpperCase() + match.substr(1);
        });
    });

    Vue.filter('currency', function (value) {
        if (undefined === value || null === value) {
            return;
        }
        return parseFloat(value).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    });

    Vue.filter('longTax', function (value) {
        if (undefined === value || null === value) {
            return;
        }
        return parseFloat(value).toLocaleString('pt-BR', {minimumFractionDigits: 4, maximumFractionDigits: 4})
    });

    Vue.filter('smallDate', function (value) {
        if (!value) {
            return;
        }
        return moment.utc(String(value)).format('DD/MM/YYYY')
    });

    Vue.filter('smallDateTime', function (value) {
        if (!value) {
            return;
        }
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
    });

    Vue.filter('smallDateTimeUtc', function (value) {
        if (!value) {
            return '';
        }
        return moment.utc(String(value)).format('DD/MM/YYYY HH:mm')
    });

    Vue.filter('federalDocument', function (value) {
        if (!value) {
            return;
        }
        value = value.replace(/[^0-9*]/g, '');
        if(value.length === 11) {
            return value.replace(/(\S{3})?(\S{3})?(\S{3})?(\S{2})/, "$1.$2.$3-$4");
        }
        if(value.length === 14) {
            return value.replace(/(\S{2})?(\S{3})?(\S{3})?(\S{4})?(\S{2})/, "$1.$2.$3/$4-$5");
        }
        if(value.length === 9 && value.match(/(\S{3})?(\S{4})?(\S{2})/)){
            let firstThree = value.substring(0, 3);
            let lastTwo = value.substring(7, 9);
            return firstThree + '.***.***-' + lastTwo;
        }
        return value;
    });

    Vue.filter('formatPhone', function (value) {
        if (!value) {
            return;
        }
        return value.replace(/(\+55)?(\d{2})?(\d{4})?(\d{4})/, "($2) $3$4");
    })
}
const app = document.getElementById('app');

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,

    // The color of the progress bar.
    color: '#29d',

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: false,
})

if(isNotTest){
    vueExtesionsAndPlugins()
    vueFilters()
    new Vue({
        render: (h) =>
            h(App, {
                props: {
                    initialPage: JSON.parse(app.dataset.page),
                    resolveComponent: (name) => require(`./Pages/${name}`).default,
                },
            }),
    }).$mount(app);
}
